export class AdminServicesViewPageContext {
    private static instance: AdminServicesViewPageContext;

    private pageContext: any;

    private constructor() { }

    private static getInstance(): AdminServicesViewPageContext {
        if (!this.instance) {
            this.instance = new AdminServicesViewPageContext();
        }
        return this.instance;
    }

    public static getPageContext(): any {
        return this.getInstance().pageContext;
    }

    public static setPageContext(newVal: any) {
        this.getInstance().pageContext = newVal;
    }
}